<template>
	<div class="groupusers">
		<!-- 头部 -->
		<minhead :headtitle="glytitle"></minhead>
		<div class="top">
		<!-- 	<div class="crumbs">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item>
						<i class="el-icon-lx-cascades"></i>
						集团管理员
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
 -->
			<div class="right" v-show="false">
				<span>当前集团</span>
				：
				<el-select v-model="choosejt" placeholder="请选择集团" @change="changegroup">
					<el-option v-for="item in AllCompanyGrouplist" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>


			</div>
		</div>

		<!-- center -->
		<div class="center">
			<div class="btn">
				<!-- <el-button type="primary" style="width: 100px;" plain @click="foraddnew('新增用户')">新增</el-button> -->
				<div class="addstyle" style="width: 100px;margin-right: 24px;" @click="foraddnew('新增用户')">新增
				</div>
				<!-- <el-button type="danger" style="width: 100px;" plain @click="handleDelete()">删除</el-button> -->
				<div class="dangestyle" style="width: 100px; margin-right: 24px;" @click="handleDelete()">删除
				</div>
			</div>
			<div class="search" style="width: 330px;">
				<el-input placeholder="搜索姓名、用户名、手机、邮箱、所属集团名称" prefix-icon="el-icon-search"  clearable v-model="likeSearchvalue" @input="changeserch"></el-input>
			</div>
		</div>

		<div class="table">
			<div class="tableh">
			<el-table ref="multipleTable" :data="tableData" style="width: 100%"  @selection-change="changeselection"  height="calc(100vh - 277px )">
				<el-table-column type="selection"  ></el-table-column>
				<el-table-column prop="userName" label="姓名"  ></el-table-column>
				<el-table-column prop="userCode" label="用户名"  ></el-table-column>
				<el-table-column prop="newuserType" label="用户角色"  ></el-table-column>
				<el-table-column prop="companyGroupName" label="所属集团"  ></el-table-column>
				<el-table-column prop="companyGroupCode" label="集团编号"  ></el-table-column>
				<el-table-column prop="phone" label="手机"  ></el-table-column>
				<el-table-column prop="email" label="邮箱"  ></el-table-column>
				<el-table-column prop="createTime" label="时间"  >
					<template slot-scope="scope">
						<div class="Centerhorizontally">
							{{formatTimestamp(scope.row.createTime)}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="150" fixed="right" align="center">
					<template slot-scope="scope">
						<el-button size="text" type="primary" @click="handleCheck(scope.$index, scope.row, '查看详情')">预览</el-button>
						<el-button size="text"  type="primary" @click="handleEdit(scope.$index, scope.row, '编辑详情')">编辑</el-button>
						<!-- <el-button size="mini" type="danger" @click="handleDelete2(scope.$index, scope.row)">删除</el-button> -->
					</template>
				</el-table-column>
			</el-table>
		</div>
			<el-pagination
				class="pagination"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:page-sizes="[10, 20, 100, 500]"
				:page-size="pagenum"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalcount"
			></el-pagination>

			<!-- 弹层 -->
			<!-- 添加弹层 -->
			<el-dialog class="dialog" :title="title" :visible.sync="dialogVisible2" width="800px" :close-on-click-modal="false" v-dialogDrag>
				<div  class="form">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="姓名" prop="userName"><el-input v-model="ruleForm.userName" :disabled="title == '查看详情'"></el-input></el-form-item>
						<el-form-item label="手机号" prop="phone"><el-input v-model="ruleForm.phone" :disabled="title == '查看详情'"></el-input></el-form-item>
						<el-form-item label="用户名" prop="userCode"><el-input v-model="ruleForm.userCode" :disabled="title == '查看详情'"></el-input></el-form-item>
						<el-form-item prop="email" label="邮箱"><el-input v-model="ruleForm.email" :disabled="title == '查看详情'"></el-input></el-form-item>

						<el-form-item label="密码" prop="password">
							<el-input type="password" :disabled="title == '查看详情'" v-model="ruleForm.password" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="checkPass"   v-if="title != '查看详情'">
							<el-input type="password" v-model="ruleForm.checkPass" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="用户类型" prop="userType"  v-show="false">
							<el-select v-model="username" disabled placeholder="集团管理员"  @change="choosemembertype">
								<el-option v-for="item in useralllist" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="集团名称" v-show="false"><el-input v-model="ruleForm.companyGroupName" disabled  ></el-input></el-form-item>
						<!--<el-form-item label="用户角色" prop="userType">
							<el-select v-model="ruleForm.roleId" placeholder="请选择"  style="width: 100%;"  :disabled="title == '查看详情'">
								<el-option
										v-for="item in roleComboData"
										:key="item.value"
										:label="item.label"
										:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="" prop="">
						</el-form-item>
						<div style="padding-left: 15px;width:100%">
							<span class="ar-title">关联实体信息</span>
							<div style="padding-top: 10px;" v-if="showRelCompanyOpBtn == true">
									<el-button plain style="width: 80px;" @click="addRelCompanyClickFun()">添加</el-button>
								<el-button plain style="width: 80px;" @click="delRelCompanyClickFun()">删除</el-button>
							</div>
							<div style="padding-top: 10px;width:100%">
								<el-table :data="ruleForm.companyList" border stripe  width="100%" height="250px" class="table" ref="relCompanyTable" @row-click="clickUserRelCompanyRowByChecked">
									<el-table-column type="selection" width="55" align="center" label="序号"></el-table-column>
									<el-table-column prop="id" v-if="showColumn"></el-table-column>
									<el-table-column prop="name" label="实体名称"  show-overflow-tooltip></el-table-column>
									<el-table-column prop="taxNumber" label="实体税号"  show-overflow-tooltip></el-table-column>
									<el-table-column prop="state" label="当前状态" :formatter="stateFormat"></el-table-column>
								</el-table>
							</div>
						</div>-->
					</el-form>

					<div class="bottombut">
						<el-button type="primary" @click="returnForm2()">返回</el-button>
						<el-button class="bottombut1" type="primary" @click="submitForm('ruleForm')" v-if="title != '查看详情'">保存</el-button>
					</div>

					<!-- <el-button @click="resetForm('ruleForm')">重置</el-button>  -->
				</div>
			</el-dialog>

			<!-- 关联实体信息 - 实体信息显示 -->
			<el-dialog title="公司信息" :visible.sync="showCompanyDataDialogVisible" width="600px" :close-on-click-modal="false" v-dialogDrag class="dialog" >
				<div class="custom-dialog">
					<div style="padding-top: 10px;">
						<el-table :data="allCompanyList" border stripe height="300px" class="table" ref="companyTable" @row-click="clickCompanyTableRowByChecked">
							<el-table-column type="selection" width="55" align="center"></el-table-column>
							<el-table-column prop="id" v-if="showColumn"></el-table-column>
							<el-table-column prop="name" label="实体名称"  show-overflow-tooltip></el-table-column>
							<el-table-column prop="taxNumber" label="实体税号"  show-overflow-tooltip></el-table-column>
							<el-table-column prop="state" label="当前状态" :formatter="stateFormat"></el-table-column>
						</el-table>
					</div>
				</div>
				<span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserRelCompanyClickFun()" style="width: 80px;">保存</el-button>
                <el-button @click="showCompanyDataDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	data() {
        var validatePass = (rule, value, callback) => {
            let reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>,.\/])(?=.*[0-9]).{8,}$/;
            if(value==''||value=='********'){
                callback();
            } else   if (!reg.test(value)) {
                callback(new Error('密码需包含大小写字母、特殊符号、数字且大于8位'));
            } else {
                callback();
            }
        };
		var validatePass2 = (rule, value, callback) => {
			if(value == ''&&this.ruleForm.password==''){
				callback();
			} else if (value === '') {
				callback(new Error('请再次输入密码'));
			} else if (value != this.ruleForm.password) {
				callback(new Error('两次输入密码不一致!'));
			} else {
				callback();
			}
		};
		var verifPhoneNumber = (rule, value, callback) => {
			var reg = /^1[0-9]{10}$/gi;//
			if (!reg.test(value)&&value) {
				callback(new Error('请输入正确手机号'));
			}else {
				callback();
			}
		};
		return {
			useropj:{},
			glytitle:['系统设置', '集团管理员'],
			likeSearchvalue: '',
			title: '查看详情',
			ruleForm: {
				userName: '',
				phone: '',
				userCode: '',
				email: '',
				password: '',
				checkPass: '',
				userType: '',
				companyGroupName: '',
				companyGroupId: '',
				version:'',
				roleId:'',
				companyIds:'',
				companyList: []
			},
			choosejt: '所有',
			choosejtid: '',
			/* 可建人员类型	 */
			username: '集团管理员',
			userType: '1',
			useralllist: [
				{
					label: '集团管理员',
					value: '1'
				},
				{
					label: '超级管理员',
					value: '0'
				},
				{
					label: '普通用户',
					value: '2'
				}
			],
			rules: {
				userName: [{ required: true, message: '请输入名字', trigger: 'blur' } ],
				phone: [{validator:verifPhoneNumber,trigger:'blur'}],
				userCode: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
				password: [{ validator: validatePass, trigger: 'blur' }],
				email: [{ required: true, message: '请输入邮箱地址', trigger: 'blur' }, { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' }],
				checkPass: [{ validator: validatePass2, trigger: 'blur' }]
			},
			input21: '',
			dialogVisible2: false,
			dialogVisible3: false,

			AllCompanyGrouplist: [],

			//table数据
			tableData: [],
			ids: '',
			totalcount:"",
			page:1,
			pagenum:10,
			userRelCompanyData: [],
			showCompanyDataDialogVisible: false,
			currGroupData: '',  //  当前集团信息
			allCompanyList: '', //  当前集团下所有实体信息
			disabled: false,    //  字段是否禁用
			disabledUserCode: false,    //  用户名是否禁用
			showRelCompanyOpBtn:false,
			showColumn:false,  //id列是否隐藏
			roleComboData: [],
			tableHeight:""
		};
	},
	mounted() {
		 this.$nextTick(() =>{
			this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
			window.onresize = () =>{
		    this.tableHeight = this.diagheight();this.$refs.multipleTable.doLayout()
		      }
		    })
	},
	created() {
		this.useropj=JSON.parse(localStorage.getItem('useropj'));
		this.AllCompanyGrouplist = [{name:this.useropj.companyGroupName,id:this.useropj.companyGroupId}];

		this.choosejt = this.useropj.companyGroupName;
		this.choosejtid = this.useropj.companyGroupId;
		this.ruleForm.companyGroupName = this.useropj.companyGroupName;
		this.ruleForm.companyGroupId = this.useropj.companyGroupId;
		// this.useropj.companyGroupName
		// this.useropj.companyGroupCode
		//this.getAllCompanyGroup();
		this.getUserList();
	},
	methods: {
		/* 搜索 */
		changeserch(e) {
			this.likeSearchvalue = e;
			this.getUserList();
		},
		/* 	选择人员类型 */
		choosemembertype(e) {
			this.userType = e;
		},
		/* 选择集团 */
		changegroup(e) {
			this.AllCompanyGrouplist.forEach(item => {
				if (item.id == e) {
					this.choosejt = item.name;
					this.choosejtid = item.id;
					this.ruleForm.companyGroupName = item.name;
					this.ruleForm.companyGroupId = item.id;
				}
			});
			this.getUserList();
		},
		/* 查看弹框弹出*/
		handleCheck(index, row, title) {
			this.title = title;
			this.dialogVisible2 = true;
			this.$nextTick(() => {
				this.$refs['ruleForm'].clearValidate();
			});
			this.getUserById(row.id);
			this.showRelCompanyOpBtn=false;
			this.ruleForm.companyList=[];
			/*this.getCompanyDataByCurrGroupId(row.companyGroupId);
			this.getRoleListByGroupId(row.companyGroupId);
			this.getUserAndCompanyMapping(row.id);*/
		},
		/* 编辑弹框弹出 */
		handleEdit(index, row, title) {
			this.ruleForm.checkPass=this.ruleForm.checkPass.replace("********","");
			this.ruleForm.password=this.ruleForm.password.replace("********","");
			if (this.$refs['ruleForm']){
				this.$nextTick(() => {
					this.$refs['ruleForm'].clearValidate();
				});
			}
			this.title = title;
			this.dialogVisible2 = true;
			this.showRelCompanyOpBtn=true;
			this.ruleForm.companyList=[];

			this.getUserById(row.id, 'update');
			/*this.getCompanyDataByCurrGroupId(row.companyGroupId);
			this.getRoleListByGroupId(row.companyGroupId);
			this.getUserAndCompanyMapping(row.id);*/
		},
		/* 	新增集团弹出*/
		foraddnew(title) {
			if (this.choosejtid == '') {
				this.$message.error(this.$tolertJSON[4000]);
				return false;
			}
			if (!this.choosejtid){
				this.$message.error(this.$tolertJSON["ISJTNULL"]);
				return false;
			}
			this.$nextTick(() => {
				this.$refs['ruleForm'].clearValidate();
			});
			this.ruleForm.companyList=[];
			this.dialogVisible2 = true;
			this.title = title;
			this.showRelCompanyOpBtn=true;
			this.getCompanyDataByCurrGroupId(this.choosejtid);
			this.getRoleListByGroupId(this.choosejtid);

			Object.keys(this.ruleForm).map(key => ((this.ruleForm[key] = ''), (this.ruleForm['companyGroupName'] = this.choosejt), (this.ruleForm['companyGroupId'] = this.choosejt)));
		},

		/* 用户保存，编辑 */
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					if (this.title == '新增用户') {
						this.addUser();
					} else if (this.title == '编辑详情') {
						this.updateUser();
					}
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		handleSizeChange(val) {
			this.pagenum=val
			this.getUserList()
		},
		handleCurrentChange(val) {
			this.page=val
			this.getUserList()
		},
		/* 返回 */
		returnForm2() {
			this.dialogVisible2 = false;
		},

		/* 多选 */
		changeselection(e) {
			this.ids = '';
			e.forEach((item, index) => {
				this.ids = this.ids + item.id + ',';
			});
			var reg = /,$/gi;
			this.ids = this.ids.replace(reg, '');
		},
			/* 多个删除 */
		/* 单个删除 */
		handleDelete() {
			this.$confirm('此操作将批量删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					if (this.ids == '') {
						this.$message({
							type: 'info',
							message: '请选择要删除的元素'
						});
					} else {
						this.deleteUsers(this.ids);
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},

		// handleDelete2(index, row) {
		// 	let id = row.id;
		// 	this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
		// 		confirmButtonText: '确定',
		// 		cancelButtonText: '取消',
		// 		type: 'warning'
		// 	})
		// 		.then(() => {
		// 			this.deleteUser(id);
		// 		})
		// 		.catch(() => {
		// 			this.$message({
		// 				type: 'info',
		// 				message: '已取消删除'
		// 			});
		// 		});
		// },


	/* 	接口调用操作 */



		/* 	查看用户 */
		getUserById(id, f) {
			let params = id;
			this.$https.fetchPost('sys/admin/getUserById', params).then(res => {
				this.ruleForm=[];
				res.data.obj.checkPass='********';
				res.data.obj.password='********';
				this.ruleForm=res.data.obj;
			});
		},
		/* 	获取集团下用户列表 */
		getUserList() {
			console.log(this.choosejtid)
			if(this.choosejtid==""){
				this.choosejtid=null
			}
			 let search={}
			 console.log(this.choosejtid);
			console.log(this.choosejtid==""||this.choosejtid==null);
			if(this.choosejtid==""||this.choosejtid==null){
				search={userType:1}
			}else{
					search={groupId:this.choosejtid,userType:1}
			}
			let params = {

				search: search,
				likeSearch: this.likeSearchvalue,
				page: this.page,
				limit: this.pagenum
			};

			this.$https.fetchPost('sys/admin/getUserList', params).then(res => {
				this.totalcount=res.data.count
				this.tableData = res.data.data;
				this.tableData.forEach(item => {
					item.newuserType = this.typetostring(item.userType);
				});
			});
		},
		/* 	新增用户 */
		addUser() {
			let params = {};
			console.log(this.ruleForm);
			params = this.ruleForm;
			this.ruleForm.companyGroupId = this.choosejtid;
			this.ruleForm.companyGroupName = this.choosejt;
			/*if (this.ruleForm.companyList){
				for (let i=0;i<this.ruleForm.companyList.length;i++){
					this.ruleForm.companyIds+=this.ruleForm.companyList[i].id+",";
					params.companyIds+=this.ruleForm.companyList[i].id+",";
				}
			}*/
			params.userType = this.userType;
			this.$https.fetchPost('sys/admin/saveUser', params).then(res => {
				if (res.data.success) {
					this.getUserList();
					this.$message.success(this.$tolertJSON[4001]);
					this.dialogVisible2 = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 批量删除用户 */
		deleteUsers(ids) {
			let params = ids;
			this.$https.fetchPost('sys/admin/deleteUsersByType', params).then(res => {
				if (res.data.success) {
					this.getUserList();
					this.$message.success(this.$tolertJSON[4004]);
					this.dialogVisible2 = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 删除用户 */
		deleteUser(id) {
			let params = id;
			this.$https.fetchPost('sys/admin/deleteUser', params).then(res => {
				if (res.data.success) {
					this.getUserList();
					this.$message.success(this.$tolertJSON[4003]);
					this.dialogVisible2 = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 更新用户 */
		updateUser() {
			let params = {};
			this.ruleForm.companyIds="";
			params = this.ruleForm;
			/*for (let i=0;i<this.ruleForm.companyList.length;i++){
				params.companyIds+=this.ruleForm.companyList[i].id+",";
			}*/
			params.userType = this.userType;
			this.$https.fetchPost('sys/admin/updatePasswordHashUser', params).then(res => {
				if (res.data.success) {
					this.getUserList();
					this.$message.success(this.$tolertJSON[4002]);
					this.dialogVisible2 = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		/* 获取集团列表 */
		getAllCompanyGroup() {
			let params = {};
			this.$https.fetchPost('sys/admin/getAllCompanyGroup', params).then(res => {
				this.AllCompanyGrouplist = res.data.obj;
				this.AllCompanyGrouplist.unshift({
                name: '所有',
                id: ''
            });
        });
		},
		getRoleListByGroupId(groupId) { //  获取当前集团下的所有用户角色数据
			this.$https.fetchPost('/sys/admin/getRoleListByCompanyGroup', groupId).then(res => {
				if(res.data.success) {
					this.assembleRoleComboData(res.data.obj);
				} else {
					this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
				}
			}, error => {
				this.$message.error('加载当前集团下用户角色信息错误：' + error);
			});
		},
		async assembleRoleComboData(roleData) {   //  拼接用户角色下拉数据
			let roleComboData = [];
			if(roleData && roleData.length > 0) {
				roleData.forEach(role => {
					roleComboData.push({value: role.id, label: role.roleName});
				});
			}
			this.roleComboData = roleComboData;
		},
		addRelCompanyClickFun() {   //  新增用户关联公司信息
			this.showCompanyDataDialogVisible = true;
			for (let i=0;i<this.ruleForm.companyList.length;i++){
				for (let k=0;k<this.allCompanyList.length;k++){
					if (this.ruleForm.companyList[i].id==this.allCompanyList[k].id) {
						this.allCompanyList.splice(k, 1);
					}
				}
			}
		},
		delRelCompanyClickFun() {   //  删除用户关联公司信息
			let checkRows = this.$refs.relCompanyTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.warning('请选择需要删除关联的公司信息！');
				return;
			}
			//数据返回到列表中
			for (let i=0;i<checkRows.length;i++){
				this.allCompanyList = this.allCompanyList.concat(checkRows[i]);
			}
			//删除被选中的公司
			for (let i=0;i<checkRows.length;i++){
				for (let k=0;k<this.ruleForm.companyList.length;k++){
					if (this.ruleForm.companyList[k].id==checkRows[i].id) {
						this.ruleForm.companyList.splice(k, 1);
					}
				}
			}
			this.ruleForm.companyList=this.ruleForm.companyList;
		},
		clickCompanyTableRowByChecked(row) {
			this.$refs.companyTable.toggleRowSelection(row);
		},
		clickUserRelCompanyRowByChecked(row) {
			this.$refs.relCompanyTable.toggleRowSelection(row);
		},
		saveUserRelCompanyClickFun() {  //  保存用户勾选的公司信息
			if (!this.ruleForm.companyList){
				this.ruleForm.companyList=[];
			}
			let checkRows = this.$refs.companyTable.selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.warning('请选择需要关联的公司信息！');
				return;
			}
			//显示用户勾选的列表
			for (let i=0;i<checkRows.length;i++){
				this.ruleForm.companyList = this.ruleForm.companyList.concat(checkRows[i]);
			}
			//删除存在对象
			for (let i=0;i<checkRows.length;i++){
				for (let k=0;k<this.allCompanyList.length;k++){
					if (this.allCompanyList[k].id==checkRows[i].id) {
						this.allCompanyList.splice(k, 1);
					}
				}
			}
			this.showCompanyDataDialogVisible = false;
		},
		getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
			this.$https.fetchPost('/sys/admin/getCompanyListByGroup', groupId).then(res => {
				if(res.data.success) {
					this.allCompanyList = JSON.parse(JSON.stringify(res.data.obj));
				} else {res.data.data;
					this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
				}
			}, error => {
				this.$message.error('获取当前集团下所有实体信息失败：' + error);
			});
		},
		getUserAndCompanyMapping(groupId) { //  获取用户已勾选的公司
			this.$https.fetchPost('/sys/admin/getUserAndCompanyMapping', groupId).then(res => {
				if(res.data.success) {
					this.ruleForm.companyList=res.data.obj;
					this.ruleForm.companyList.push({});
					this.ruleForm.companyList.pop({});
					this.$forceUpdate();
				} else {
					this.$message.error('获取当前用户下所有实体信息失败：' + res.data.message);
				}
			}, error => {
				this.$message.error('获取当前用户下所有实体信息失败：' + error);
			});
		},
		stateFormat(row, column, cellValue, index) {
			if (row.state == "0") {
				return "正常";
			} else if (row.state == "1") {
				return "停用";
			}else{
				return row.state;
			}
		},
		chage(e){
			this.$forceUpdate()
		}
	}
};
</script>

<style scoped>
	/deep/.el-table--small td {
	    padding: 4px 0;
	}
/deep/.el-table__body-wrapper {
		min-height: 200px;
	}
.btn {
	display: flex;
	margin-top: 20px;
	margin-bottom: 20px;
}
.pagination {
	margin-top: 15px;
}
.bottombut {
	margin-top: 20px;

	display: flex;
	justify-content: flex-end;
}
.groupusers {
	padding:0 10px;
}

.top {
	
}
.center {
	display: flex;
	justify-content: space-between;
}
.center .btn {
	margin-bottom: 15px;
}
.search{
	margin-top: 25px;
}

.el-form {
	display: flex;
	flex-wrap: wrap;
}

.el-form-item {
	width: 50%;
}
</style>
